<template>
  <div class="row">
    <div class="col-lg-12">
      <client-info :clientId="clientId"></client-info>

      <h4 class="row-title" v-if="!isPreviousDateSession">{{'dro.interactive_modules' | trans }}</h4>
      <modules-list :clientId="clientId" v-if="!isPreviousDateSession"></modules-list>

      <h4 v-if="(isBCBA || isCurator) && !isPreviousDateSession" class="row-title pt-4">{{'protocol.conflict_sessions' | trans }}</h4>
      <conflict-protocol-list v-if="(isBCBA || isCurator) && !isPreviousDateSession" :clientId="clientId" :reload="reloadBids"></conflict-protocol-list>

      <h4 class="row-title pt-4" id="protocol">{{'protocol.active_protocols' | trans }}</h4>
      <assigned-protocol-list :clientId="clientId" :reload="reloadBids"></assigned-protocol-list>

      <h4 class="row-title pt-4" v-if="!isPreviousDateSession">{{'protocol.bids_for_protocols' | trans }}</h4>
      <bids-list :userId="clientId" v-if="!isPreviousDateSession" v-on:list-reload=reloadList></bids-list>
    </div>

    <dashboard-menu></dashboard-menu>

  </div>
</template>

<script>
  import ClientInfo from './ClientInfo';
  import AssignedProtocolList from './AssignedProtocolList';
  import ConflictProtocolList from './ConflictProtocolList';
  import ModulesList from './ModulesList';
  import BidsList from '@/modules/bids/components/BidsList';
  import {showModal} from '../../../../common/mixins/showModal'
  import DashboardMenu from '../../../dashboardParent/components/DashboardMenu';
  import {mapGetters} from 'vuex';

  export default {
    name: 'ClientProfile',
    props: ['clientId'],
    data() {
      return {
        client: {},
        protocols: [],
        disabled: false,
        onlyList: false,
        reloadBids: false,
      };
    },
    computed: {
      ...mapGetters('auth', [
        'isCurator',
        'isBCBA',
        'isPreviousDateSession'
      ]),
    },
    mixins: [showModal],

    components: {
      ClientInfo, AssignedProtocolList, BidsList, ModulesList, DashboardMenu, ConflictProtocolList
    },
    methods: {
      reloadList(){
        this.reloadBids = true;
        setTimeout(() => {
          this.reloadBids = false;
        }, 500);

      }
    },
    mounted() {
      const anchor = this.$router.currentRoute.hash;
      this.$nextTick(() => {
        if (anchor && document.querySelector(anchor)) {
          location.href = anchor;
        }
      });
    }
  };
</script>



// WEBPACK FOOTER //
// src/modules/user/client/components/Profile.vue